import { Component, Input, OnInit } from '@angular/core';
import { FormDataResult, FormLock, IconStyle } from '@wdx/shared/utils';
import { FormLockService } from '../../../services';

@Component({
    selector: 'wdx-ff-lock-summary',
    templateUrl: './form-lock-summary.component.html',
    standalone: false,
    host: { class: 'd-block w-100' },
})
export class FormLockSummaryComponent implements OnInit {
    @Input() formData!: FormDataResult;

    shouldOverride!: boolean;

    readonly ICON_STYLE = IconStyle;

    constructor(private formLockService: FormLockService) {}

    ngOnInit(): void {
        this.shouldOverride = !!this.formLockService.shouldOverrideFormLock(
            this.formData.lock as FormLock,
        );
    }
}
